import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';

import { Snapshot, Vdd, VddsByLogicalLink } from '@vi-iot/client';
import { BackupSeparator } from '../_common/backup-separator';
import { SnapshotDetailsDemoMode } from './remote-diagnostics-snapshots.model';
import { RemoteDiagnosticsSnapshotsStore } from './remote-diagnostics-snapshots.store';

@Injectable({ providedIn: 'root' })
export class RemoteDiagnosticsSnapshotsService {
  backupsForDemo: Snapshot[] = [];
  snapshotsForDemo: Snapshot[] = [];
  snapshotDetailsForDemo: SnapshotDetailsDemoMode[] = [];

  constructor(private store: RemoteDiagnosticsSnapshotsStore) {}

  convertRawVddListToVddByLL(vddList: Vdd[]): VddsByLogicalLink[] {
    const logicalLinksSet = new Set<string>();
    vddList.forEach((vdd) => logicalLinksSet.add(vdd.logicalLink));

    const vddListByLogicalLinks: VddsByLogicalLink[] = [];
    logicalLinksSet.forEach((uniquelLogicalLink) => {
      const vddListWithUniqueLogicalLink: VddsByLogicalLink = {
        logicalLinkName: uniquelLogicalLink,
        vddNames: [],
      };
      vddListByLogicalLinks.push(vddListWithUniqueLogicalLink);
    });

    vddList.forEach((vdd) =>
      vddListByLogicalLinks
        .find((vddListByLogicalLink) => vddListByLogicalLink.logicalLinkName === vdd.logicalLink)
        ?.vddNames?.push(BackupSeparator.removeBackupSeparator(vdd.key))
    );

    return vddListByLogicalLinks;
  }

  selectIsAnySelectedParameterInvalid$: Observable<
    boolean
  > = this.store.getSelectedParametersForNewSnapshot$.pipe(
    switchMap((selectedParameters) => {
      const invalidSelectorsCheck = selectedParameters.map((parameter) =>
        this.store.isSelectedSnapshotParameterInvalid(parameter.key, parameter.logicalLink)
      );

      return combineLatest([...invalidSelectorsCheck]);
    }),
    map((invalidOperatorsCheck) => invalidOperatorsCheck.some((isInvalid) => isInvalid))
  );
}
